export default function SingleRatingIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <div className={className}>
      <svg
        width={`1em`}
        height={`1em`}
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.43469 0.690721C7.73404 -0.23059 9.03745 -0.230588 9.3368 0.690723L10.6309 4.6735C10.7648 5.08553 11.1487 5.36448 11.5819 5.36448H15.7697C16.7384 5.36448 17.1412 6.6041 16.3575 7.1735L12.9695 9.635C12.619 9.88964 12.4724 10.341 12.6062 10.753L13.9003 14.7358C14.1997 15.6571 13.1452 16.4232 12.3615 15.8538L8.97353 13.3923C8.62304 13.1377 8.14844 13.1377 7.79796 13.3923L4.41 15.8538C3.62629 16.4232 2.57181 15.6571 2.87116 14.7358L4.16524 10.753C4.29912 10.341 4.15246 9.88964 3.80197 9.635L0.414017 7.1735C-0.369697 6.6041 0.0330806 5.36448 1.0018 5.36448H5.18955C5.62277 5.36448 6.00673 5.08552 6.1406 4.6735L7.43469 0.690721Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
